import { render, staticRenderFns } from "./form-input-label.vue?vue&type=template&id=2d40ff38&scoped=true"
import script from "./form-input-label.vue?vue&type=script&lang=js"
export * from "./form-input-label.vue?vue&type=script&lang=js"
import style0 from "./form-input-label.vue?vue&type=style&index=0&id=2d40ff38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40ff38",
  null
  
)

export default component.exports